import colours from '../../tokens/colours';
import fonts from '../../tokens/fonts';
import FontWeights from '../../tokens/fontWeights';
import FontStyles from '../../tokens/fontStyles';
const resetStyles = {
    'html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video': {
        'margin': 0,
        'padding': 0,
        'border': 0,
        'fontSize': '10px',
        'font': 'inherit',
        'verticalAlign': 'baseline',
        'box-sizing': 'border-box',
        textDecoration: 'none',
        color: colours.black,
        fontFamily: fonts.roboto,
        fontWeight: FontWeights.Medium,
        fontStyle: FontStyles.Normal,
    },
    'article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section': {
        'display': 'block',
    },
    'body': {
        'lineHeight': 1,
    },
    'ol, ul': {
        'listStyle': 'none',
    },
    'blockquote, q': {
        'quotes': 'none',
    },
    'blockquote:before, blockquote:after, q:before, q:after': {
        'content': 'none',
        'fallbacks': [
            {
                'content': '\'\'',
            },
        ],
    },
    'table': {
        'borderCollapse': 'collapse',
        'borderSpacing': 0,
    },
    'input, textarea, button': {
        all: 'unset'
    },
    'textarea': {
        resize: 'none'
    }
};
export default resetStyles;
//# sourceMappingURL=resetStyles.js.map